import HeaderComponent from '../components/header';
import { connect } from 'react-redux';
function mapStateToProps(state, ownProps) {
    return {
        embedHost: state.config.embedHost,
        nationalCloud: state.config.nationalCloud,
        currentView: state.config.currentView,
        correlationId: state.config.correlationId,
        query: ownProps.query
    };
}
export const Header = connect(mapStateToProps)(HeaderComponent);
export default Header;
